import React from "react";
import Slider from "react-slick";
import "../../assets/vendor/slick-master/slick/slick.scss";
import "../../assets/vendor/slick-master/slick/slick-theme.scss";
import { Row } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import TitleGroup, {
  Title,
  SeeAllButton,
} from "../../components/common/TitleGroup";
import OfferCard from "../../components/OfferCard";
import { useQuery } from "react-query";
import { ApiNames, fetchData } from "../../remote-data/fetchData";

import routes from "../../constants/routes";
import { Loader } from "../../utils/common";

import { settingsOffers } from "./_settings";
function Offers() {
  // API: GET
  const { data: postData, isLoading: isPostLoading } = useQuery(
    ApiNames.COLLECTION_LIST,
    () =>
      fetchData(ApiNames.COLLECTION_LIST, {
        // pathValues: [props.spaceId],
        // params: { size: 5 }
      })
  );
  if (isPostLoading || !postData) return <Loader />;
  // console.log(postData && postData.data.collections); //[0].collection, [0].offers
  return (
    <div>
      {postData &&
        postData.data.collections.map((item) => (
          <div key={item.collection.id}>
            <TitleGroup>
              <Title title={item.collection.title} />
              <SeeAllButton
                link={`${routes["collections"]}/${item.collection.id}/offers`}
              />
              {/*  */}
            </TitleGroup>

            {item.offers.length < 4 ? (
              <div className="not-slick-slider">
                <Row className="row-gap-10">
                  {item.offers.map((o) => (
                    <Colxx key={o.id} col="6" sm="6" md="4" lg="3">
                      <OfferCard postItem={o} />
                    </Colxx>
                  ))}
                </Row>
              </div>
            ) : (
              <Slider className="" {...settingsOffers}>
                {item.offers.map((o) => (
                  <div key={o.id}>
                    <OfferCard postItem={o} />
                  </div>
                ))}
              </Slider>
            )}
          </div>
        ))}
    </div>
  );
}

export default Offers;
